export type PatchedFieldsAction = PatchedFieldsComputed;

export function patchedFieldsComputed(formId: string, patchedFields: readonly string[]) {
  return {
    type: 'PATCHED_FIELDS_COMPUTED' as const,
    formId,
    patchedFields,
  };
}
export type PatchedFieldsComputed = ReturnType<typeof patchedFieldsComputed>;
